/**
 * @author HungNS
 */
/* eslint-disable no-unused-vars */
import Vue from "vue";
import VueQrcode from '@chenfengyuan/vue-qrcode';

const ComponentPlugin = {
    install(Vue, options) {
        Vue.component(VueQrcode.name, VueQrcode);
        registerComponents(require.context('@/views/force-news/components/force-news-blocks', true, /\.vue$/i));
        registerComponents(require.context('@/components/common/modal', true, /\.vue$/i));
        registerComponents(require.context('@/components/base', true, /\.vue$/i));
    },
};

function registerComponents(require) {
    require.keys().map((key) => {
        const component = require(key).default;
        const name = component.name;
        if (!name) {
            window.console.warn(`missing name in vue component. ${key}`);
        } else {
            Vue.component(name, component);
        }
    });
}

export default ComponentPlugin;
